import { buildPgCardRows } from "../../../features/bonds/shared/components/sections/pgSectionConfig";
import { isHighBondAmount } from "./components/guardianFormHelpers";
export {
  getOccupationQuestionLabel,
  hasPiiAccessForSsn,
  isHighBondAmount,
} from "./components/guardianFormHelpers";
export {
  formatHistoricSsnDisplay as formatRetrievalSsnDisplay,
  gVal,
} from "../Bond Creation Historic/historicGuardianUtils";

/**
 * @param {object|null} pg
 * @param {string} pgAddressOptionKey — option key for mailing address (`address`, `guardian_street_address_1`, …)
 */
export function retrievalBuildPgCardRows(pg, pgAddressOptionKey = "address") {
  return buildPgCardRows(pg, { addressOptionKey: pgAddressOptionKey });
}

/** @returns {boolean} */
export function retrievalShowsRelationshipRelationshipField(cfg, guardian) {
  const pgYes = guardian.is_professional_guardian === "Yes";
  const attYes = guardian.is_attorney === "Yes";
  if (cfg.relationshipShowWhen === "notPgNotAttorney") return !pgYes && !attYes;
  return !pgYes;
}

/**
 * Mirrors prior retrieval guardian occupation visibility vs bond high amount.
 * @returns {boolean}
 */
export function retrievalShowsOccupationBlock(guardian, globalData, cfg) {
  if (!cfg.showManualOccupation) return false;
  if (cfg.manualOccupationWhen === "never") return false;
  const bondAmt =
    globalData?.basicInformation?.bondAmount ??
    globalData?.bond_amount;
  if (!isHighBondAmount(bondAmt)) return false;
  if (
    cfg.manualOccupationWhen === "highBondNotPgNotAttorney" ||
    cfg.manualOccupationWhen === "always"
  ) {
    return (
      guardian.is_professional_guardian !== "Yes" &&
      guardian.is_attorney !== "Yes"
    );
  }
  return false;
}

export function retrievalShowsEmailRow(guardian, globalData, cfg) {
  return (
    Boolean(guardian.is_new_pg) ||
    globalData?.basicInformation?.is_esignatures === "Yes"
  );
}

export function retrievalLabeledCreatableDisabledProps(
  selectDisabledPropName,
  isDisabled
) {
  return selectDisabledPropName === "isDisabled"
    ? { isDisabled }
    : { disabled: isDisabled };
}
